class Player {
    id;
    name;
    money;
    address;
    tableId;

    constructor(id, name, money, address, tableId) {
        this.id = id;
        this.name = name;
        this.money = money;
        this.address = address;
        this.tableId = tableId;
    }
}

export default Player;
